// extracted by mini-css-extract-plugin
module.exports = {"cookie-settings":"CookieSettings_cookie-settings__5EtfP","cookieSettings":"CookieSettings_cookie-settings__5EtfP","button":"CookieSettings_button__zWN49"};